import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../components-v2/Button';
import { baseStyleSheet, bs } from '../../styles/styles';
import { TextInputFormField } from '../TextInputFormField';

interface IAutoSaveTemplateNameModalProps {
	/** Save the template under the provided name and keep autosave on for this newsletter */
	onSave: (name: string) => void;
	/** Disable autosave for this newsletter only — the persisted default is left unchanged */
	onTurnOffForThisNewsletter: () => void;
	/** Persist autosave as off so future newsletters open with autosave disabled */
	onTurnOffByDefault: () => void;
}

export const AutoSaveTemplateNameModal: React.FC<IAutoSaveTemplateNameModalProps> = ({
	onSave,
	onTurnOffForThisNewsletter,
	onTurnOffByDefault,
}) => {
	const [name, setName] = React.useState('');

	const handleSave = () => {
		const trimmedName = name.trim();
		if (trimmedName) {
			onSave(trimmedName);
		}
	};

	return (
		<div className={css(bs.boxBorder)}>
			<div className={css(bs.textTitles, bs.textLg)}>Name this template to enable autosave</div>
			<div className={css(bs.pt2, bs.textSm)}>
				Autosave needs a saved template. Give this HTML Newsletter a name and we&apos;ll keep it saved as you edit. You
				can always toggle autosave on or off per template using the Autosave checkbox.
			</div>
			<div className={css(bs.pt6)}>
				<div className={css(bs.textHeader, bs.textXs)}>
					Template Name:
					<span className={css(baseStyleSheet.required)}>*</span>
				</div>
				<TextInputFormField
					autoFocus
					className={css(bs.mt1)}
					maxLength={255}
					onChange={ev => setName(ev.target.value)}
					onKeyDown={ev => {
						if (ev.key === 'Enter' && name.trim()) {
							handleSave();
						}
					}}
					type='text'
					value={name}
				/>
			</div>
			<div className={css(bs.mt5, bs.flex, bs.flexCol, bs.gap2)}>
				<Button disabled={!name.trim()} onClick={handleSave}>
					Save and enable autosave
				</Button>
				<Button variant='secondary' onClick={onTurnOffForThisNewsletter}>
					Turn off autosave for this newsletter
				</Button>
				<Button variant='secondary' onClick={onTurnOffByDefault}>
					Turn off autosave by default
				</Button>
			</div>
		</div>
	);
};
